{% block ecocode_trustpilot_info_text %}
    <span class="ecocode-trustpilot-info-text">
        {% block ecocode_trustpilot_info_text_icon %}
            <sw-icon :name="icon" size="14" :color="color"></sw-icon>
        {% endblock %}
        {% block ecocode_trustpilot_info_text_content %}
            <span>{{ text }}</span>
        {% endblock %}
    </span>
{% endblock %}
